import React from 'react';
import { components, SingleValueProps } from 'react-select';

import { DepartureOption } from '@lt/api/dist/types/departure';

import { LocationIcon } from '../../styles';

export const SingleValue = (props: SingleValueProps<DepartureOption, false>) => {
  const { data } = props;

  return (
    <components.SingleValue {...props}>
      <span>из {data.selectedLabel}</span>
      {data.isAutomaticallyDetected && <LocationIcon />}
    </components.SingleValue>
  );
};
